import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import AuthContext from "../../contexts/authContext";
import Loading from "../../components/shared/Loading";
import { apiURL, getData, patchData, postData } from "../../services/API";
import NoticeMsg from "../../components/shared/NoticeMsg";
import { CheckError } from "./checkError";
import { useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";

import form from "../../components/shared/Form/form.json";
import fa from "../core/lang/fa.json";
import { idGenerator, translateLabel } from "../../helper/helper";

// forms & api
import Input from "../../components/shared/Form/Input";
import config from "./config.json";
import { UserData } from "../../contexts/UserInfoContext";
import { useNavigate } from "react-router-dom";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { RefContextData } from "../../contexts/RefContext";
import axios from "axios";

const ProfileInfo = ({ profile, companyInfo }) => {
  // const { refCode, setRefCode } = useContext(RefContextData)

  // destructor
  const {
    api_url: { pc_complete_info, g_user_profile },
  } = config;

  const navigate = useNavigate();

  // useForm hook
  const { register, getValues, setValue } = useForm();
  const [selectedGender, setSelectedGender] = useState({
    name: "مرد",
    code: "male",
  });
  const [genders, setGenders] = useState([
    { name: "مرد", code: "male" },
    { name: "زن", code: "female" },
    { name: "دیگر", code: "other" },
  ]);

  const registerInputes = new Map(Object.entries(pc_complete_info.input));

  const toastLogin = useRef(null);
  const textInputes = [];
  const passwordInput = [];

  // context
  const authContext = useContext(AuthContext);
  const { setUser } = useContext(UserData);

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  // referral code lookup state
  const [refCodeValue, setRefCodeValue] = useState("");
  const [refLookupLoading, setRefLookupLoading] = useState(false);
  const [refUser, setRefUser] = useState(null);
  const [refError, setRefError] = useState(false);
  const refDebounceTimer = useRef(null);

  const ref = getItemStorage("ref");

  useEffect(() => {
    const initialRef = ref || "";
    setValue("ref_code", initialRef);
    setRefCodeValue(initialRef);
    if (initialRef) {
      lookupReferralCode(initialRef);
    }
  }, []);

  const lookupReferralCode = useCallback((code) => {
    if (!code || code.trim() === "") {
      setRefUser(null);
      setRefError(false);
      setRefLookupLoading(false);
      return;
    }
    setRefLookupLoading(true);
    setRefUser(null);
    setRefError(false);
    axios
      .post("https://api.myunibest.ir/api/user/get-user-by-code", { code: code.trim() })
      .then((res) => {
        setRefUser(res.data?.user?.display_name || null);
        setRefError(!res.data?.user?.display_name);
      })
      .catch(() => {
        setRefUser(null);
        setRefError(true);
      })
      .finally(() => {
        setRefLookupLoading(false);
      });
  }, []);

  const handleRefCodeChange = (e) => {
    const val = e.target.value;
    setRefCodeValue(val);
    setValue("ref_code", val);

    if (refDebounceTimer.current) clearTimeout(refDebounceTimer.current);
    refDebounceTimer.current = setTimeout(() => {
      lookupReferralCode(val);
    }, 600);
  };

  registerInputes.forEach((item, value) => {
    textInputes.push(
      item.type === "text" && value !== "ref_code" && (
        <Input
          key={idGenerator()}
          element={"input"}
          type={item.type}
          label={item.label}
          placeHolder={item.label}
          register={{ ...register(value) }}
          error={errMsg[value]}
          wrapperClass="text-input-register"
        />
      )
    );
  });

  registerInputes.forEach((item, value) => {
    passwordInput.push(
      item.type === "password" && (
        <div className="flex flex-col gap-2">
          <Input
            key={idGenerator()}
            element={"input"}
            type={showPassword ? "text" : "password"}
            label={item.label}
            placeHolder={item.label}
            register={{ ...register(value) }}
            error={errMsg[value]}
            wrapperClass=" animate-delay-6"
          />

          <span className="text-gray-400 text-xs">
            رمز عبور باید شامل حروف بزرگ و کوچک انگلیسی، اعداد و کاراکتر های
            خاص(#$%&...) باشد.
          </span>
        </div>
      )
    );
  });

  const submitHandler = (e) => {
    e.preventDefault();

    if (
      getValues("name") &&
      getValues("family_name") &&
      getValues("password")
    ) {
      setErrMsg({});
      setLoading(true);
      setValidate(false);
      postData(
        pc_complete_info.url,
        {
          phone_number: authContext.userInfo.phone_number,
          ...getValues(),
          vcode: authContext.userInfo.vcode,
          gender: selectedGender.code,
        },
        false
      )
        .then((res) => {
          authContext.userCompleteProfile(res.data, { ...getValues() });

          // toast message
          toastLogin.current.show({
            severity: "success",
            summary: "ثبت نام با موفقیت انجام شد",
            detail: "در حال انتقال به پنل کاربری...",
            life: 3500,
          });

          // get user data
          getData(g_user_profile.url, {}, true)
            .then((res) => {
              setLoading(false);
              setUser(res.data);
              if (res.data.user.name.includes("Admin")) {
                navigate("/admin");
              } else {
                navigate("/user");
              }
            })
            .catch((err) => {});
        })
        .catch((error) => {
          toastLogin.current.show({
            severity: "error",
            summary: "خطا هنگام تکمیل پروفایل",
            detail: error.response.data.message,
            life: 3500,
          });

          setLoading(false);
          setErrMsg(error.response.data);
        });
    } else {
      setValidate(true);
    }
  };

  return (
    <div>
      {/* toast message */}
      <Toast ref={toastLogin} />

      {validate && (
        <NoticeMsg msg={"تمامی فیلد ها الزامی میباشند."} notice={"error"} />
      )}
      <div
        className={`complete-register flex flex-col gap-4 mt-6 transition-all duration-300`}
      >
        {/* text inputes */}
        {textInputes}

        {/* referral code input */}
        <div className="flex flex-col gap-2 animate-delay-3">
          <label className="text-gray-200 text-sm">کد معرف (اختیاری)</label>
          <input
            type="text"
            value={refCodeValue}
            onChange={handleRefCodeChange}
            placeholder="کد معرف را وارد کنید"
            className="h-[50px] w-full rounded-xl bg-[#222222] border border-gray-800 text-gray-200 px-4 text-sm outline-none focus:border-yellow-600 transition-colors duration-200 text-right"
            dir="ltr"
          />

          {/* loading / result row */}
          {refLookupLoading && (
            <div className="flex items-center gap-2 text-gray-400 text-xs pr-1">
              <svg
                className="animate-spin w-4 h-4 text-yellow-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                />
              </svg>
              <span>در حال بررسی کد معرف...</span>
            </div>
          )}

          {!refLookupLoading && refUser && (
            <div className="flex items-center gap-2 text-green-400 text-xs pr-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              <span>معرف شما: <span className="font-semibold text-green-300">{refUser}</span></span>
            </div>
          )}

          {!refLookupLoading && refError && refCodeValue.trim() !== "" && (
            <div className="flex items-center gap-2 text-red-400 text-xs pr-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
              <span>کد معرف معتبر نیست</span>
            </div>
          )}
        </div>

        {/* radio inputes */}
        <div className="flex flex-col gap-2 animate-delay-4">
          <label className="text-gray-200">جنسیت</label>
          <Dropdown
            className="h-[50px] w-full filter-dropdown bg-[#222222] !text-gray-200 !border-gray-800 flex items-center justify-center rounded-xl"
            value={selectedGender}
            options={genders}
            optionLabel="name"
            onChange={(e) => setSelectedGender(e.value)}
            placeholder="جنسیت خود را انتخاب کنید"
          />
        </div>

        {/* password input */}
        <div className="relative">
          {passwordInput}

          <button
            onClick={() => setShowPassword(!showPassword)}
            className="cursor-pointer outline-none border-none absolute top-[45px] left-3"
          >
            {showPassword ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 stroke-yellow-700"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 stroke-yellow-700"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            )}
          </button>
        </div>

        {!loading ? (
          <button
            onClick={submitHandler}
            style={
              companyInfo.name && {
                background: `linear-gradient(to top left, #${companyInfo.color}, #${companyInfo.color}80)`,
              }
            }
            disabled={loading}
            className="bg-gradient-to-tl from-yellow-900 to-yellow-500 animate-delay-8 text-white w-full h-11 rounded-xl shadow-lg transition-all duration-300"
            type="submit"
          >
            تکمیل اطلاعات پروفایل
          </button>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default ProfileInfo;
